import styled from 'styled-components';
import { colors } from '../../styles/colors';
import { theme, toRem } from '../../styles';

export const StyledAmenititesModal = styled.div`
  .prearrival-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(5px);
  }

  .modal-heading {
    font-size: 30px !important;
    line-height: normal !important;
  }

  .dining-request-modal {
    background-color: ${colors.white};
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    max-width: 596px;
    padding: 53px 71px 49px !important;
    position: relative;
    z-index: 10000;
    margin: 0 auto;
    max-height: calc(100% - 56px);
    overflow-y: auto;
    @media ${theme.mediaQuery.allMobiles} {
      max-width: 330px;
      border-radius: 8px;
      padding: 66px 28px 35px !important;
    }
  }

 

  .close-button-container {
    position: absolute;
    top: -30px;
    right: -30px;
    @media ${theme.mediaQuery.allMobiles} {
      top: -57px;
      right: -5%;
    }
  }

  .close-button {
    border: none;
    width: 32px;
    height: 32px;
    font-size: 16px;
    color: ${colors.black} !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    background-color: ${colors.neutral20} !important;
  }

  .subtitle {
    text-align: left;
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(24)} var(--t-base-font-family) !important;
  }

  button {
    width: 100%;
    border-radius: 0px;
  }
  button[aria-label="Submit Request"]{
    padding: 8px 24px;
    font-weight:400;
    line-height:17px;
    font: normal normal 700 ${toRem(13)} / ${toRem(16)} var(--t-base-font-family) !important;
  }

  .inside-div2 {
    padding: 0px 90px;
    @media ${theme.mediaQuery.allMobiles} {
      padding: 0px;
    }
    p {
      font: normal normal 700 ${toRem(14)} / ${toRem(20)} var(--t-base-font-family) !important;
    }

    .party-size-text {
      font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family) !important;
    }

    .date-picker-container {
    position:relative;
      &.addVal{
        input[type="date"]::-webkit-datetime-edit-text,
        input[type="date"]::-webkit-datetime-edit-month-field,
        input[type="date"]::-webkit-datetime-edit-day-field,
        input[type="date"]::-webkit-datetime-edit-year-field {
          color: var(--t-brand-fg-color) !important;
        }
        input[type="date"].date-input--has-value::-webkit-datetime-edit-text,
        input[type="date"].date-input--has-value::-webkit-datetime-edit-month-field,
        input[type="date"].date-input--has-value::-webkit-datetime-edit-day-field,
        input[type="date"].date-input--has-value::-webkit-datetime-edit-year-field {
          color: var(--t-brand-fg-color) !important;
        }
        .date-picker {
          color: var(--t-brand-fg-color) !important;
        }
      }
   }
    
    .date-picker {
      position: relative !important;
      display: inline-block;
      width: 135px;
      height: 32px;
      padding: 10px 0px 10px 5px;
      font: normal normal normal ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
      border: 1px solid var(--t-input-fields-bg-color);
      border-radius: 0px;
      appearance: none;
      display: flex;
      color: ${colors.grey6} !important;
      caret-color: var(--t-brand-fg-color) !important;
      &:focus {
        border: 1px solid var(--t-input-fields-bg-color);
      }
       @media ${theme.mediaQuery.allMobiles} {
      display: flex;
      justify-content: flex-start;
      padding: 3px 20px 3px 5px !important;
      }
      @media not all and (min-resolution: 0.001dpcm) and (background: -webkit-named-image(i)) {
        padding: 5px 22px 5px 0px !important;
        padding-right: 22px !important;
        padding-left: 0px !important;
        padding-top: 5px !important;

      }
        &.time-picker.error-border{
        border: 1px solid #d13438 !important;
        }
    }


    .date-picker::after {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      top: 44%;
      right: 10%;
      border-left: 1px solid var(--t-brand-fg-color);
      border-bottom: 1px solid var(--t-brand-fg-color);
      transform: rotate(-45deg) translateY(-50%);
      pointer-events: none;
       @media ${theme.mediaQuery.allMobiles} {
       right: 8%;
       }
       
    }

    .singledatepicker {
      position: absolute; /* Position the calendar absolutely within the container */
      left: 0; /* Align it with the left side of the input field */
      z-index: 1; /* Ensure the calendar is above the input field */
      bottom:100%;  
    }
       
     option{
      color: var(--t-brand-fg-color);
    }

    .time-picker {
      .m-dropdown-field {
       height: 32px;
       margin-left:18px;
        padding: 5px 10px 5px 15px;
        background-color: var(--t-button-primary-fg-color);
        font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(
  20
)} var(--t-base-font-family) !important;
        border-radius: 0px;
        border: 1px solid var(--t-input-fields-bg-color);
        @media ${theme.mediaQuery.allMobiles} {
        max-width: 266px;
      }
    }

    .container-width {
      max-width: 266px;
    }
  }

  .modal-select {
    max-width: 277px;
    height: 32px;
    padding: 5px 5px 5px 15px;
    background-color: var(--t-button-primary-fg-color);
    color: var(--t-brand-fg-color) ;
    font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(20)} var(--t-base-font-family) !important;
    border-radius: 0px;
    border: 1px solid var(--t-input-fields-bg-color);
  }

  .time-text {
    font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(12)} var(--t-base-font-family) !important;
    margin-left: 10px !important;
    text-align: right;
  }

  
    .custom-select-wrapper{
      &.party-size{
        width:272px;
      }
        :after{
         top:45% !important; 
        }
      select {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none; 
          padding-right: 30px;
          position: relative;
          background: none;
          font-family: inherit;
        }
      .m-dropdown-field{
        width:124px !important;
      }
    }

    .custom-select-wrapper {
      position: relative;
      display: inline-block;
      select{
      &.error-select-border,.m-dropdown-field {
	            border: 1px solid #d13438 !important;
        }
      }
    }

    .custom-select-wrapper::after {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      top: 48%;
      right: 6%;
      border-left: 2px solid var(--t-brand-fg-color);
      border-bottom: 2px solid var(--t-brand-fg-color);
      transform: rotate(-45deg) translateY(-50%);
      pointer-events: none;
      transition: transform 0.3s;
    }

     select:invalid {
      color: ${colors.grey6} !important;
    }
      .input-icon {
    position: absolute;
    width: 8px;
    height: 8px;
    top: 8px;
    right: 15%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .input-icon i {
    color: var(--t-brand-fg-color);
    font-style: normal;
  }
  .DayPicker-wrapper-react-el {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
  }
    .error-container {
	display: flex;
	text-align: left !important;
	align-items: flex-start !important;

}

.error-icon {
	margin-right: 2px;
	display: inline-flex;

	i {
		margin-top: 2px !important;
		font-style: normal;
		color: var(--t-form-error-color);
		font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / 1rem var(--t-base-font-family) !important;
    line-height:10px !important;
	}
}

.error-message {
	font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / 1rem var(--t-base-font-family) !important;
	color: var(--t-form-error-color);
	padding-top: 2px;
  line-height:10px !important;
}

.error-select-border,.time-picker.error-border .m-dropdown-field  {
	border: 1px solid #d13438 !important;
}
.red-asterisk {
  color: var(--t-form-error-color);
}
`;
